import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import accountCheck from '@tencent/vft-common/openapp/openapp-account-check';
import { loginService, userService, vipService } from '@vip-activity/business';
import util from '@tencent/vft-common/util';
import { replaceUrl } from '@/util/';
import { removeHttp } from '@vip-activity/base';
import { shieldRun } from '@vip-activity/utils';
import { openUrl as _openUrl, openApp } from '@tencent/kid-util';
import { buildUrl } from '@tencent/vft-common/url';
import params from '../config';
Vue.mixin({
  data: function data() {
    return _objectSpread(_objectSpread({}, params), {}, {
      loginService: loginService,
      userService: userService,
      vipService: vipService,
      defaultAvatar: 'https://vfiles.gtimg.cn/vupload/20210128/9e5e9a1611813615699.png',
      defaultXqe: 'https://vfiles.gtimg.cn/vupload/20210126/default.png',
      accountCheck: accountCheck
    });
  },
  filters: {
    removeHttp: removeHttp,
    hideNick: util.hideNick,
    formatNum: util.formatNum,
    getSecond: function getSecond(time) {
      return parseInt(time % 60, 10);
    },
    getMinute: function getMinute(time) {
      return parseInt(time / 60, 10);
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['now'])), mapState(['now', 'isKidAppInstall', 'hasGoldBelt', 'todayLaisee', 'receivedLaisee', 'fetcherList', 'historyRecord', 'isOwner', 'remainNum', 'magicInfo', 'lotteryList', 'firstgetGoldBelt', 'lotteryFlowList', 'lotteryNextFlowList'])), {}, {
    红包天数: function 红包天数() {
      var _window$setting$红包区域,
          _this = this;

      var day = 10;
      var dayList = ((_window$setting$红包区域 = window.setting.红包区域) === null || _window$setting$红包区域 === void 0 ? void 0 : _window$setting$红包区域.红包列表) || [{
        天数: '30',
        开始时间: '2021-02-01 00:00:00',
        结束时间: '2021-02-03 23:59:59'
      }, {
        天数: '20',
        开始时间: '2021-02-04 00:00:00',
        结束时间: '2021-02-05 23:59:59'
      }, {
        天数: '10',
        开始时间: '2021-02-06 00:00:00',
        结束时间: '2021-02-19 23:59:59'
      }];
      dayList.forEach(function (item) {
        if (_this.now > new Date(item.开始时间) && _this.now < new Date(item.结束时间)) {
          day = item.天数;
        }
      });
      return day;
    },
    userAvatar: function userAvatar() {
      return this.userService && this.userService.headurl || this.defaultAvatar;
    },
    isEnd: function isEnd() {
      console.log('isEnd', this.$store.state.now, new Date(window.timeSetting.活动截止时间));
      return this.$store.state.now > new Date(window.timeSetting.活动截止时间) || params.test === '1' && params.end === '1';
    },
    isLogin: function isLogin() {
      return loginService.isLogin;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations(['setState'])), mapActions(['updateFetcherList', 'getTodayLaisee', 'createTodayLaisee'])), {}, {
    hideNick: function hideNick() {
      return util.hideNick.apply(util, arguments);
    },
    getSecond: function getSecond(time) {
      return parseInt(time % 60, 10);
    },
    getMinute: function getMinute(time) {
      return parseInt(time / 60, 10);
    },
    replaceUrl: replaceUrl,
    shieldRun: shieldRun,
    $openLogin: function $openLogin() {
      this.loginService.openLogin();
    },
    delUrlParams: function delUrlParams(param) {
      var _this2 = this;

      if (!(param instanceof Array)) {
        // eslint-disable-next-line no-param-reassign
        param = [param];
      }

      param.forEach(function (item) {
        _this2.replaceUrl(util.delQueStr(window.location.href, item), true);
      });
    },
    loginTips: function loginTips() {
      var _this3 = this;

      this.confirm({
        msg: '当前登录态已过期，请重新登录',
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _this3.$openLogin();
        }
      });
    },
    isSchema: function isSchema() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return url.match(/^(txvideo|tenvideo2)/);
    },
    openMidPage: function openMidPage(url) {
      this.openUrl(buildUrl(window.setting.红包中间页, {
        url: url
      }, true));
    },
    openPageWithAccount: function openPageWithAccount(param) {
      var url = window.location.href;

      if (this.isLogin) {
        url = buildUrl(url, _objectSpread({
          vuid: this.vuid,
          type: this.userService.type,
          nick: this.userService.nick,
          head: this.userService.headurl
        }, param), true);
      }

      this.openMidPage(url);
    },
    openKidUrl: function openKidUrl(url) {
      if (env.isKidApp) {
        _openUrl.openUrlInKidApp(url);

        return;
      }

      this.openMidPage(url);
    },
    shareRedPacket: function shareRedPacket() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this4.loading.show();

                _context.next = 4;
                return _this4.getTodayLaisee();

              case 4:
                console.debug('todayLaisee', _this4.todayLaisee); // 没有创建过红包

                if (_this4.todayLaisee) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return _this4.createTodayLaisee();

              case 8:
                console.debug('todayLaisee created', _this4.todayLaisee);

              case 9:
                if (_this4.todayLaisee) {
                  _this4.eventBus.$emit('openShare');
                } // if (!this.todayLaisee) {
                //   // this.toast('创建红包失败，请稍后再试');
                // }


              case 10:
                _context.prev = 10;

                _this4.loading.hide();

                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0,, 10, 13]]);
      }))();
    },
    openUrl: function openUrl(url) {
      if (!url) {
        return;
      }

      console.log("env.isKidApp:".concat(env.isKidApp));

      if (env.isKidApp) {
        if (env.isAndroid && url.indexOf('http') === 0) {
          window.location.href = url;
          return;
        }

        _openUrl.openUrlInKidApp(url);

        return;
      }

      if (url.indexOf('qqlivekid') === 0) {
        console.log('openApp.openKidApp', url);
        openApp.openKidApp(url);
        return;
      }

      if (this.isSchema(url)) {
        accountCheck.openApp(url);
      } else if (env.isApp) {
        var subUrl = url.indexOf('//') === 0 ? window.location.protocol + url : url;
        atom.invoke('openView', {
          url: "txvideo://v.qq.com/HollywoodH5Activity?url=".concat(encodeURIComponent(subUrl))
        });
      } else {
        window.location.href = url;
      }
    },
    downLoadApp: function downLoadApp() {
      openApp.downloadApp();
    },
    openProperty: function openProperty() {
      if (env.isKidApp && !loginService.isLogin) {
        loginService.openLogin();
        return;
      }

      this.openUrl('https://film.qq.com/weixin/v3/asset/index.html?header=0&tab=award');
    }
  })
});